<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='vehicleServiceBO.ajax?cmd=doQueryVehicleWaringList'
          :params="fullSearchData"
          bizName="客户线路数据导出"
          bizCode="exp100020"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          />
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import {
  warnList,
} from 'api/archives';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'driverUserTel',
            label: '司机手机',
          },
          {
            prop: 'driverUserName',
            label: '司机姓名',
          },
          {
            prop: 'orgName',
            label: '归属部门',
          },
          {
            prop: 'relUserName',
            label: '归属员工',
          },
          {
            prop: 'waringTypeName',
            label: '预警类型',
          },
          {
            prop: 'waringDate',
            label: '预警时间',
          },
          {
            prop: 'waringRemark',
            label: '预警内容',
          },
          {
            prop: 'dealStateName',
            label: '状态',
          },
          {
            prop: 'dealTime',
            label: '处理时间',
          },
          {
            prop: 'dealUserName',
            label: '处理人',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: warnList,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
